export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4739.7c873702.jpg";